var path = 'directives/displayTimeframe/displayTimeframe.html';
var html = "<span><span ng-show=!vm.currentOnly>{{vm.timeframes[vm.startTimeframe]}} -</span> {{vm.timeframes[vm.currentTimeframe]}}</span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./js/directives/displayTimeframe/displayTimeframe.html
 ** module id = 175
 ** module chunks = 0
 **/